import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';

import BlogDataAccess from "../../utils/BlogDataAccess";
import BlogListingLayout from "./BlogListingLayout";
import MetaTagsManipulator from "../../utils/MetaTagsManipulator";

function BlogCategoryPage() {
    const {categoryLink} = useParams();

    const [blogDataAccess] = useState(new BlogDataAccess());
    const [availableCategories, setAvailableCategories] = useState(new Map());
    const [categoryPosts, setCategoryPosts] = useState(null);

    useEffect(() => {
        blogDataAccess.getAvailableCategories().then(setAvailableCategories);
    }, []);

    useEffect(() => {
        setCategoryPosts(null);
        if (categoryLink === "najnowsze") {
            blogDataAccess.getNewPosts().then(setCategoryPosts);
        } else {
            blogDataAccess.getPostsByCategoryLink(categoryLink).then(setCategoryPosts);
        }
    }, [categoryLink]);

    const categoryName = availableCategories.get(categoryLink)
        || (categoryLink === "najnowsze" ? "Najnowsze" : categoryLink.replace(/-/g, ' '));

    MetaTagsManipulator.setTitle("Blog - " + categoryName);

    return (
        <div id="content">
            <div className="blog2-section">
                <div className="blog2-page-wrapper">
                    <h1 className="blog2-page-title">Blog</h1>

                    <BlogListingLayout
                        heading={categoryName}
                        posts={categoryPosts}
                        categories={availableCategories}
                        activeCategoryLink={categoryLink}
                    />
                </div>
            </div>
        </div>
    );
}

export default BlogCategoryPage;
